import cn from 'classnames';
import React from 'react';

import './inputOutlet.style.scss';
interface IInputOutletProps extends React.HTMLProps<HTMLInputElement> {
  label: string;
  secondaryTitle?: React.ReactNode;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
  preIcon?: string;
  labelClass?: string;
  customClass?: string;
  leftLabel?: string;
}

const LikeInputOutlet = ({
  label,
  required = false,
  errors,
  touched,
  name,
  secondaryTitle,
  preIcon,
  labelClass,
  customClass,
  leftLabel,
  ...props
}: IInputOutletProps) => {
  return (
    <div className={cn('floating-like-label-input')}>
      {preIcon && !props.value && (
        <i
          className={`absolute right-3 top-1/2 ml-2 text-xl -translate-y-1/2 ${preIcon}`}
        />
      )}
      <div className="relative">
        <input
          type={props.type}
          id={name}
          name={name}
          onChange={props.onChange}
          {...props}
          className={
            (touched && errors && !props.disabled ? 'invalid ' : '') +
            (touched && !errors && !props.disabled && props.value
              ? 'valid'
              : '')
          }
        />
        <label className={!props.value ? labelClass : ''} htmlFor={name}>
          {label} {required && label && <span className="color-red-3">*</span>}
        </label>
        {/* {secondaryTitle && ( */}
        <span className="text-sm secondary-title">{secondaryTitle}</span>
        {/* )} */}
        {/* left Label */}
        {leftLabel && (
          <span className="absolute top-3 left-3 text-gray-400">
            {leftLabel}
          </span>
        )}
      </div>
      {touched && errors && !props.disabled && (
        <>
          <div className="pt-1">
            <small>
              <i className="icon-warning"></i> {errors}
            </small>
          </div>
          {!secondaryTitle && (
            <span className="input-icon invalid">
              <i className="icon-error-field"></i>
            </span>
          )}
        </>
      )}

      {touched && !errors && !props.disabled && !secondaryTitle && (
        <span className="input-icon valid">
          <i className="icon-success-field"></i>
        </span>
      )}
    </div>
  );
};

export default LikeInputOutlet;
